/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { timeout } from 'ember-concurrency';
import { task } from 'ember-concurrency';
import Ember from 'ember';
import { UserFlags } from 'cio/models/user';
import AuthService from 'cio/services/auth';
import { inject as service } from '@ember/service';

interface ScheduledTaskArgs {
  taskAction: () => unknown;
  lastUpdated: number;
  interval?: number;
  message?: string;
  disabled?: boolean;
}

export default class ScheduledTask extends Component<ScheduledTaskArgs> {
  @service auth!: AuthService;
  key: keyof UserFlags = 'save_auto_refresh';

  get interval() {
    return this.args.interval ?? 10000;
  }

  get message() {
    return this.args.message ?? 'Last updated';
  }

  get autoRefreshValue(): boolean {
    return this.auth.user?.userFlags[this.key] ?? false;
  }

  scheduleTask = task({ drop: true }, async () => {
    while (this.autoRefreshValue) {
      await timeout(this.interval);
      this.args.taskAction();

      if (Ember.testing && this.auth.user != null) {
        // eslint-disable-next-line dot-notation
        this.auth.user.userFlags['save_auto_refresh'] = false;
      }
    }
  });

  @action
  toggleRefresh() {
    if (this.auth.user == null) {
      throw new Error('Unable to find current user. Refresh the page and try again.');
    }

    this.auth.user.updateUserFlag(this.key, !this.autoRefreshValue);

    if (this.autoRefreshValue) {
      this.scheduleTask.perform();
    } else {
      this.scheduleTask.cancelAll();
    }
  }
}
